import React from 'react';
import { nx, ny } from '../flowCanvas.constants';
import ImageOverlayCardNode from './ImageOverlayCardNode';

function normalizeSingleImageItem(item, fallbackTitle) {
  if (!item) return { filename: null, name: fallbackTitle };
  if (typeof item === 'string') return { filename: item, name: fallbackTitle };
  if (item.filename) return { ...item, name: item.name || fallbackTitle };
  return { filename: item, name: fallbackTitle };
}

export default function StatusScreenImageNode({
  step,
  selected,
  onClick,
  centreY,
  overrideX,
  overrideY,
  assetFolder,
  campaignId,
  item,
}) {
  const x = overrideX ?? nx(step);
  const y = overrideY ?? ny(step, centreY);
  const imageItem = normalizeSingleImageItem(item, step.stepTitle || 'Status Screen');

  return (
    <ImageOverlayCardNode
      item={imageItem}
      index={0}
      selected={selected}
      onClick={onClick}
      overrideX={x}
      overrideY={y}
      assetFolder={assetFolder}
      campaignId={campaignId}
      label={step.customisationConfig?.variables?.[0]?.displayLabel || step.stepTitle || 'Status Screen'}
      fallbackTitleBase={step.stepTitle || 'Status Screen'}
      typeLabel="Screen Image"
    />
  );
}